export default __webpack_public_path__ + "static/media/new-7.14decf17.png";